export default __webpack_public_path__ + "static/media/WhiteonTransparent.952f4028.png";